import {
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@mui/material';
import { useAuth, useUserSession } from 'hooks';
import { useUi } from 'hooks/useUi';
import { updateUserSession } from 'lib/firebase';
import { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { ColorThemes, setTheme } from 'store/features/ui';
import { UserPreferencesSession } from 'types/User/firebaseTypes';

export const ColorThemeSelector = () => {
    const { ui } = useUi();
    const { user } = useAuth();
    const session = useUserSession();
    const dispatch = useDispatch();

    const handleChange = (_: ChangeEvent<HTMLInputElement>, value: string) => {
        dispatch(setTheme(value));
        //Update user session data.
        if (user?.uid) {
            const sessionEntry: UserPreferencesSession = {
                ...session?.userPreferences,
                theme: value as ColorThemes,
            };
            updateUserSession(user.uid, 'userPreferences', sessionEntry);
        }

        // Update local storage cookie.
        localStorage.setItem('colorTheme', value);
    };

    return (
        <div data-testid="ColorThemeSelector">
            <FormControl>
                <FormLabel id="demo-controlled-radio-buttons-group">
                    Theme
                </FormLabel>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={ui.theme}
                    onChange={handleChange}
                >
                    <FormControlLabel
                        value="light"
                        control={<Radio />}
                        label="Light"
                    />
                    <FormControlLabel
                        value="dark"
                        control={<Radio />}
                        label="Dark"
                    />
                    <FormControlLabel
                        value="legacyLight"
                        control={<Radio />}
                        label="Legacy Light"
                    />
                    <FormControlLabel
                        value="legacyDark"
                        control={<Radio />}
                        label="Legacy Dark"
                    />
                </RadioGroup>
            </FormControl>
        </div>
    );
};
